var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['document-status', _vm.className]},[(_vm.className==='sai-product-status-current')?[_c('i',{staticClass:"si si-check-circle"})]:_vm._e(),_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }